export default {
  namespaced: true,
  state () {
    return {
      userProfile: null,
    }
  },
  mutations: {
    updateUserProfile (state, payload) {
      state.userProfile = payload
    },
  },
  actions: {
    updateUserProfile (context, payload) {
      context.commit("updateUserProfile", payload)
    },
  },
  getters: {
    getUserProfile (state) {
      return {
        userProfile: state.userProfile,
      }
    },
  },
}
